export const namespaced = true;

export const state = {
  login: {
    view: false
  },
  signUp: {
    view: false
  },
  drawer: {
    view: false
  },
  askToCompleteProfile: {
    view: false
  }
};
export const mutations = {
  CLOSE_LOGIN_VIEW() {
    state.login.view = false;
  },
  OPEN_LOGIN_VIEW() {
    state.login.view = true;
  },
  CLOSE_SIGNUP_VIEW() {
    state.signUp.view = false;
  },
  OPEN_SIGNUP_VIEW() {
    state.signUp.view = true;
  },
  CLOSE_DRAWER_VIEW() {
    state.drawer.view = false;
  },
  OPEN_DRAWER_VIEW() {
    state.drawer.view = true;
  },
  CLOSE_ASKTOCOMPLETEPROFILE_VIEW() {
    state.askToCompleteProfile.view = false;
  },
  OPEN_ASKTOCOMPLETEPROFILE_VIEW() {
    state.askToCompleteProfile.view = true;
  }
};
export const actions = {
  closeLoginView({ commit }) {
    commit("CLOSE_LOGIN_VIEW");
  },
  openLoginView({ commit }) {
    commit("OPEN_LOGIN_VIEW");
  },
  closeSignUpView({ commit }) {
    commit("CLOSE_SIGNUP_VIEW");
  },
  openSignUpView({ commit }) {
    commit("OPEN_SIGNUP_VIEW");
  },
  closeDrawerView({ commit }) {
    commit("CLOSE_DRAWER_VIEW");
  },
  openDrawerView({ commit }) {
    commit("OPEN_DRAWER_VIEW");
  },
  closeAskToCompleteProfileView({ commit }) {
    commit("CLOSE_ASKTOCOMPLETEPROFILE_VIEW");
  },
  openAskToCompleteProfileView({ commit }) {
    commit("OPEN_ASKTOCOMPLETEPROFILE_VIEW");
  }
};
export const getters = {};
